import React from 'react';

interface SettingsHeaderProps {
  headerText: string;
  subText: string;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ headerText, subText }) => {
  return (
    <div className="h-24 bg-surface border-b border-strong flex flex-col justify-center pl-6 py-4">
      <h1 className="text-2xl font-semibold mb-2">{headerText}</h1>
      <p className="text-content-secondary text-xs leading-5">{subText}</p>
    </div>
  );
};

export default SettingsHeader;
